import React, { ReactNode } from 'react';
import cx from 'clsx';

import style from './index.module.css';

interface FlexProps extends React.ComponentPropsWithoutRef<'div'> {
  column?: boolean;
  className?: string;
  children: ReactNode;
}

export const Flex = ({ column, children, className, ...rest }: FlexProps) => (
  <div {...rest} className={cx(style.flex, column ? style.flexColumn : style.flexRow, className)}>
    {children}
  </div>
);

export default Flex;
